export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-transition-group/esm/utils/reflow.js
// module id = 245
// module chunks = 0